import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { Ripple } from 'vuetify/lib/directives';
import pt from 'vuetify/lib/locale/pt';

Vue.use(Vuetify, { directives: { Ripple } });

export default new Vuetify({
  lang: {
    locales: { pt },
    current: 'pt',
  },
});
